var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUnlinked24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.002,
    viewBox: "0 0 16 18.002",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_unlinked24x24",
    transform: "translate(-3 -1.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25240",
    "data-name": "Group 25240",
    transform: "translate(3 1.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24982",
    "data-name": "Group 24982",
    transform: "translate(.857 7.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46077",
    "data-name": "Path 46077",
    d: "M9.4,165.658a3.475,3.475,0,0,0-.6-.481,3.586,3.586,0,0,0-4.46.481L1.083,168.9a3.573,3.573,0,0,0,5.058,5.049l2.653-2.885a.255.255,0,0,0-.18-.435h-.1a4.312,4.312,0,0,1-1.635-.316.256.256,0,0,0-.279.056l-1.9,2.135a1.532,1.532,0,0,1-2.17-2.163l3.263-3.252a1.536,1.536,0,0,1,2.167,0,1.05,1.05,0,0,0,1.439,0,1.007,1.007,0,0,0,0-1.432Z",
    transform: "translate(-.039 -164.614)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24984",
    "data-name": "Group 24984",
    transform: "translate(6.334 2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46078",
    "data-name": "Path 46078",
    d: "M198.113,1.045a3.585,3.585,0,0,0-5.06,0l-.984.928a.255.255,0,0,0,.186.435h.094a4.3,4.3,0,0,1,1.633.318.256.256,0,0,0,.279-.056l.228-.174a1.532,1.532,0,1,1,2.17,2.163l-2.4,2.388-.021.022L193.4,7.9a1.536,1.536,0,0,1-2.167,0,1.05,1.05,0,0,0-1.439,0,1.014,1.014,0,0,0,0,1.439,3.548,3.548,0,0,0,1.022.713c.054.025.107.046.161.068s.11.04.164.061.11.038.164.053l.151.04c.1.025.2.046.309.064a3.565,3.565,0,0,0,.38.036h.194l.154-.018c.056,0,.115-.015.18-.015h.09l.18-.025.082-.015.148-.031h.028a3.58,3.58,0,0,0,1.659-.938l3.253-3.244a3.561,3.561,0,0,0,0-5.046Z",
    transform: "translate(-189.497 -.001)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46237",
    "data-name": "Path 46237",
    d: "M9.072,5.817a.854.854,0,0,1-.714-.384L6.644,2.843a.869.869,0,0,1,.237-1.2.852.852,0,0,1,1.189.239L9.785,4.475a.869.869,0,0,1-.238,1.2A.849.849,0,0,1,9.072,5.817Z",
    transform: "translate(-2.279 -1.499)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46238",
    "data-name": "Path 46238",
    d: "M6.642,7.682a.854.854,0,0,1-.54-.189L1.821,4.038a.869.869,0,0,1-.134-1.214.854.854,0,0,1,1.205-.135L7.177,6.144a.869.869,0,0,1,.134,1.213A.854.854,0,0,1,6.642,7.682Z",
    transform: "translate(-1.499 -1.636)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46239",
    "data-name": "Path 46239",
    d: "M4.928,10.091a.85.85,0,0,1-.27-.044L2.088,9.184a.865.865,0,0,1-.54-1.093.855.855,0,0,1,1.084-.547L5.2,8.408a.864.864,0,0,1-.27,1.683Z",
    transform: "translate(-1.5 -2.317)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUnlinked24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_unlinked24x24.69eb0d7d00ddc3c2ac1396518ece0f55.svg";